module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0, false, false), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "container"
  }, [_vm._m(1, false, false), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.rowData.name))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 m-t-10"
  }, [_c('p', {
    staticClass: "txt"
  }, [_vm._v(_vm._s(_vm.rowData.description))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.companies), function(row, index) {
    return _c('div', {
      staticClass: "col-md-3 col-sm-4 col-xs-6"
    }, [_c('div', {
      staticClass: "store_list"
    }, [_c('div', {
      staticClass: "store_box"
    }, [_c('router-link', {
      attrs: {
        "to": '/store/' + row.comid
      }
    }, [_c('figure', {
      staticClass: "pic justify"
    }, [_c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": 'https://files.i80.com.tw/images/product/' + row.com_image
      }
    })]), _vm._v(" "), _c('h5', {
      staticClass: "title"
    }, [_vm._v(_vm._s(row.com_name))])])], 1)])])
  })), _vm._v(" "), _vm._m(2, false, false)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "container"
  }, [_c('figure', [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/images/index/i80banner.png"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', {
    staticClass: "breadcrumb hidden-xs"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v("首頁")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/alliance"
    }
  }, [_vm._v("聯盟中心")])]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("中心介紹")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    attrs: {
      "aria-label": "..."
    }
  }, [_c('ul', {
    staticClass: "pagination"
  }, [_c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "href": "#",
      "aria-label": "Previous"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("«")])])]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("1 "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("(current)")])])]), _vm._v(" "), _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "href": "#",
      "aria-label": "Next"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("»")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-070a193c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AllianceView.vue
// module id = 286
// module chunks = 1